<template>
    <LoadingCard v-if="loading"></LoadingCard>
    <div v-else>
        <ChemicalCommercialVariants :cropTypeId="cropTypeId" />
    </div>
</template>

<script>
import currentUserQuery from '@views/ChemicalCommercialVariants/Browse/queryCurrentUser.graphql';

import ChemicalCommercialVariants from './/Browse.vue';

export default {
  name: 'ChemicalCommercialVariantsContainer',
  components: {
    ChemicalCommercialVariants,
  },
  apollo: {
    currentUser: {
      query: currentUserQuery,
    },
  },
  watch: {
    currentUser() {
      const validRole = ['association', 'developer', 'admin'].includes(this.currentUser.role.name);

      if (!validRole) {
        this.$notifyFailure('Not allowed.');
        setTimeout(() => this.$router.push({ name: 'dashboard' }), this.$redirectTimeout);
      }
    },
  },
  computed: {
    cropTypeId() {
      return this.$path.get(this.currentUser, 'managedAssociation.crop_type_id');
    },
  },
  data() {
    return {
      currentUser: null,
      loading: 0,
    };
  },
};
</script>
